import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {properties} from "../../utils/properties";
import {ThreeDots} from 'react-loader-spinner';
import axios from "axios";
//#F5F5F5
//#30720F
//#3c4936
export default function ChatPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [question, setQuestion] = useState("");
  const [chat, setChat] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading]= useState(true);  

  useEffect(() => {
    loadHistory();
    if (id) loadChat(id);
  }, [id]);

  const loadHistory = async () => {
    
    const res = await axios.get(properties.productionUrl+properties.productionUrlSuffix +'/core/rest/history.php',{ withCredentials: true });
    setHistory(res.data);
    setLoading(false);
  };

  const loadChat = async (chatId) => {
    
    const res = await axios.get(properties.productionUrl+properties.productionUrlSuffix +`/core/rest/chat.php?id=${chatId}`,{ withCredentials: true });
    setChat(res.data);
  };

  /*const sendQuestion = async () => {
    if (!question) return;

    const formData = new FormData();
    formData.append("question", question);    

    const res = await axios.post(properties.productionUrl+properties.productionUrlSuffix +'/core/rest/ask.php', formData, { withCredentials: true });
    navigate(`/chat/${res.data.id}`);
  };*/

  const sendQuestion = async () => {
    if (!question) return;
  
    try {
      setLoading(true);   
      const formData = new FormData();
      formData.append("question", question);
  
      const res = await axios.post(
        properties.productionUrl + properties.productionUrlSuffix + '/core/rest/ask.php',
        formData,
        { withCredentials: true }
      );  
      navigate(`/chat/${res.data.id}`);
  
    } catch (error) {
      console.error("Errore durante la richiesta:", error);
    } finally {
      setLoading(false); 
    }
  };

  /*
  const formatResponse = (response) => {
    return JSON.stringify(response, null, 2);
  };*/
  const formatResponse = (response) => {
    if (!response) return "";
  
    // Se è oggetto JSON → formatta
    if (typeof response === "object") {
      return JSON.stringify(response, null, 2);
    }
  
    // Se è stringa → sostituisce \n con newline reale
    if (typeof response === "string") {
      return response.replace(/\\n/g, "\n");
    }
  
    return response;
  };

  return (
    <div style={{background: "#97b887", width:"100%"}}>     
    {loading ? (
        <div key={1111} style={{ width:"25%",   display: "flex",   minHeight: "100vh",
        marginLeft: "auto", marginRight: "auto" }}> 
         <ThreeDots color="#97b887" height='350' width='150'/>
         </div> 
    ):(
    <div style={{ display: "flex", height: "calc(100vh - 70px)", fontFamily: "Arial"}}>
             
      {/* Sidebar */}
      <div style={{
        width: "250px",
        background: "#97b887 ",
        color: "black",
        padding: "15px",
        overflowY: "auto"
      }}>
        <h3>Ultime domande</h3>
        {history.map((item) => (
          <div
            key={item.id}
            style={{
              padding: "10px",
              cursor: "pointer",
              borderBottom: "1px solid #333"
            }}
            onClick={() => navigate(`/chat/${item.id}`)}
          >
            {item.question.substring(0, 40)}...
          </div>
        ))}
      </div>

      {/* Main */}
      <div style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        //background: "#343541",
        background: "#F5F5F5",
        color: "white",
          
      }}>
        
        {/* Chat area */}
        <div style={{ flex: 1, padding: "20px", overflowY: "auto" }}>
          {chat && (
            <>
              <div style={{ marginBottom: "20px", color:"#000000", }}>
                <b>Domanda:</b>
                <div>{chat.question}</div>
              </div>

              <div style={{ marginBottom: "20px", color:"#000000", }}>
                <b>Risposta:</b>
                <pre style={{
                  //background: "#444654",
                  background: "#FFFFFF",
                  color:"#000000",
                  padding: "15px",
                  borderRadius: "8px",
                  whiteSpace: "pre-wrap"
                }}>
                  {formatResponse(chat.response)}
                </pre>
              </div>
            </>
          )}
        </div>

        {/* Input */}
        <div style={{
          padding: "20px",
          background: "#c4c8c2",
          display: "flex"
        }}>
          <input
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Scrivi la tua domanda..."
            style={{
              flex: 1,
              padding: "10px",
              borderRadius: "6px",
              border: "none",
              marginRight: "10px"
            }}
          />
          <button
            onClick={sendQuestion}
            style={{
              padding: "10px 20px",
              borderRadius: "6px",
              border: "none",
              background: "#3c4936",
              color: "white",
              cursor: "pointer"
            }}
          >
            Invia
          </button>
        </div>
      </div>
    </div>
    )}
    </div>
  );
}